"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
const globals_1 = require("../../infra/globals");
const date_utils_1 = require("../../infra/date_utils");
const env_1 = require("../../infra/env");
const utils_1 = require("../../infra/utils");
const router_1 = require("../../routing/router");
const game_record_1 = require("../../models/game_record");
const ui_utils_1 = require("../ui_utils");
const game_records_table_1 = __importDefault(require("../components/game_records_table"));
const elo_1 = __importDefault(require("../../models/elo"));
class GameRecordView extends HTMLElement {
    gameRecordRef;
    static tag = "game-record-view";
    constructor(gameRecordRef) {
        super();
        this.gameRecordRef = gameRecordRef;
    }
    getGameRecord = async () => {
        const playerDoc = await (0, firestore_1.getDoc)((0, firestore_1.doc)(globals_1.db, "game_records", this.gameRecordRef));
        this.gameRecord = (0, utils_1.addFirebaseRef)(playerDoc.data(), playerDoc.id);
    };
    async connectedCallback() {
        document.title = "Partida";
        this.prepareGameRecordPage();
        await this.getGameRecord();
        if (this.gameRecord) {
            document.title = `
        Partida | 
          ${this.gameRecord.blackPlayer.name} 
          vs 
          ${this.gameRecord.whitePlayer.name}
      `;
            this.setGameRecordPage();
        }
    }
    prepareGameRecordPage = () => {
        this.innerHTML += `
      <div id="players-names"></div>
      
      <div id="card"></div>

      <div id="glift"></div>
    `;
    };
    setGameRecordPage = () => {
        this.setPlayersNames();
        this.setGameRecordCard();
        this.addSgfDiagram();
        this.append(new game_records_table_1.default("Partidas entre", this.gameRecord.blackRef, this.gameRecord.whiteRef));
    };
    setPlayersNames = () => {
        const playerNamesDiv = this.querySelector("#players-names");
        const [black, white] = [
            this.gameRecord.blackPlayer,
            this.gameRecord.whitePlayer,
        ];
        const [blackWins, whiteWins] = this.blackWhiteWins;
        const [blackFlags, whiteFlags] = [
            ui_utils_1.UiUtils.allFlags(black.nationalities),
            ui_utils_1.UiUtils.allFlags(white.nationalities),
        ];
        const [blackElo, whiteElo] = [
            new elo_1.default(black.currentElo),
            new elo_1.default(white.currentElo),
        ];
        playerNamesDiv.innerHTML = `
      <div id="black">
        <svg>
          <circle 
            cx="25" 
            cy="25" 
            r="15" 
            stroke="white" 
            stroke-width="2.5" 
            fill="black" />
        </svg>

        <route-link href="${router_1.RouteEnum.players}/${this.gameRecord.blackRef}">
          ${ui_utils_1.UiUtils.playerPicture(this.gameRecord.blackPlayer.picture)}
          <span ${blackWins}>${black.name}</span>
          ${blackFlags}
          <span>${blackElo.danKyuLevel()}</span>
        </route-link>
      </div>

      <div id="white">
        <svg>
          <circle 
            cx="25" 
            cy="25" 
            r="14.5" 
            stroke="black" 
            stroke-width="2.5" 
            fill="white" />
        </svg>

        <route-link href="${router_1.RouteEnum.players}/${this.gameRecord.whiteRef}">
          ${ui_utils_1.UiUtils.playerPicture(this.gameRecord.whitePlayer.picture)}
          <span ${whiteWins}>${white.name}</span>
          ${whiteFlags}
          <span>${whiteElo.danKyuLevel()}</span>
        </route-link>
      </div>
    `;
    };
    get blackWhiteWins() {
        return [
            this.gameRecord.result.whoWins === game_record_1.Color.Black ? "winner" : "loser",
            this.gameRecord.result.whoWins === game_record_1.Color.White ? "winner" : "loser",
        ];
    }
    setGameRecordCard = () => {
        const gameRecordCardDiv = this.querySelector("#card");
        const gameDate = new Date(this.gameRecord.date);
        const formattedDate = date_utils_1.DateUtils.formatDate(gameDate);
        const handicap = this.gameRecord.handicap ? this.gameRecord.handicap : "0";
        const [blackWins, whiteWins] = this.blackWhiteWins;
        const sgfButton = this.gameRecord.sgf
            ? `<a id="download">SGF</a>`
            : `<span>${globals_1.emdash}</span>`;
        gameRecordCardDiv.innerHTML = `
      <div id="legend">
        <span>Elo Dif Preto</span>
        <span>Elo Preto</span>
        <span>Compensação</span>
        <span>Data</span>
        <span>Resultado</span>
        <span>Baixar</span>
        <span>Evento</span>
        <span>Elo Branco</span>
        <span>Elo Dif Branco</span>
      </div>

      <div id="content">
        <span ${blackWins}>
          ${ui_utils_1.UiUtils.signedEloDelta(this.gameRecord.eloData.eloDeltaBlack)}
        </span>

        <span>${this.gameRecord.eloData.atTheTimeBlackElo}</span>

        <span>${handicap}</span>

        <span>${formattedDate}</span>

        <span>${(0, game_record_1.resultString)(this.gameRecord.result)}</span>

        ${sgfButton} 

        ${ui_utils_1.UiUtils.gameEventLink(this.gameRecord)}
        
        <span>${this.gameRecord.eloData.atTheTimeWhiteElo}</span>

        <span ${whiteWins}>
          ${ui_utils_1.UiUtils.signedEloDelta(this.gameRecord.eloData.eloDeltaWhite)}
        </span>
      </div>
    `;
        if (this.gameRecord.sgf)
            this.setDownloadButton();
    };
    setDownloadButton = () => {
        const sgfDownloadA = this.querySelector("a#download");
        const gameDate = new Date(this.gameRecord.date);
        const formattedDate = date_utils_1.DateUtils.formatDate(gameDate).replaceAll("/", "-");
        const [blackName, whiteName] = [
            this.gameRecord.blackPlayer.name,
            this.gameRecord.whitePlayer.name,
        ];
        const blob = new Blob([this.gameRecord.sgf], {
            type: "text/plain;charset=utf-8",
        });
        const fileUrl = URL.createObjectURL(blob);
        const fileName = `${formattedDate} - ${blackName} vs ${whiteName}`;
        sgfDownloadA.download = `${fileName}.sgf`;
        sgfDownloadA.href = fileUrl;
    };
    addSgfDiagram = () => {
        if (!this.gameRecord.sgf) {
            const gliftDiv = this.querySelector("div#glift");
            gliftDiv.style.display = "none";
        }
        else {
            const gliftScript = document.createElement("script");
            gliftScript.type = "text/javascript";
            const gliftScriptName = "glift_1_1_2.min.js";
            gliftScript.src =
                env_1.envState === env_1.EnvState.dev
                    ? `/local/${gliftScriptName}`
                    : `/${gliftScriptName}`;
            gliftScript.toggleAttribute("async");
            gliftScript.onload = () => {
                try {
                    glift.create({
                        divId: "glift",
                        sgf: {
                            sgfString: this.gameRecord.sgf,
                        },
                        display: {
                            theme: "DEPTH",
                            goBoardBackground: "images/purty_wood.png",
                            disableZoomForMobile: true,
                        },
                    });
                }
                catch (e) {
                    console.log(e);
                }
            };
            document.head.appendChild(gliftScript);
        }
    };
}
exports.default = GameRecordView;
//# sourceMappingURL=data:application/json;base64,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